import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';

const angle = 30;

export class cjsClock extends cjsItem {
  _type;
  _aid = 0;
  _move;
  _listener = {};
  _rotStart;
  _angHr;

  _angleTips;

  constructor(obj) {
    super(obj);
    this._aid = 0;
    this._move = false;
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    if (typeof this.otherProperty.clock === 'object' && this.otherProperty.clock !== null) {
      switch (this.otherProperty.clock.type.toLowerCase()) {
        case 'min':
          this._type = 'min';
          break;
        case 'hr':
          this._type = 'hr';
          break;
        default:
          throw 'Ustaliłeś nie poprawny typ wskazówki dla grupy: ' + this.idGroup + ' dla elementu: ' + this.id;
          break;
      }

      if (typeof this.otherProperty.clock.tip !== 'object' || this.otherProperty.clock.tip === null)
        throw 'Brak konfiguracji drugiej wskazówki dla grupy: ' + this.idGroup + ' elementu: ' + this.id;

      this._move = _.cloneDeep(this.otherProperty.clock.tip);
    }

    this._angleTips =
      (typeof this.otherProperty === 'object' && fJS.isNumeric(this.otherProperty.angleMinTips)
        ? this.otherProperty.angleMinTips
        : this._stage.defConfig.clock.angleMinTips) * 6;
  }

  stageMouseDown(e, data) {
    let stage = data.cjsStage,
      engine = data.engine;

    stage.resetCheckStatus();
    if (stage.mousedown === true || engine.block === true || engine.move === false) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;
    console.log(engine);
    /** w przypadku gdy wybrana wskazówka jest godzinową, to minutowa jest ustawiana na pozycję startową, */

    if (this.type === 'hr') {
      stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation =
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotStart;
    } else {
      engine.angHr = stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation;
    }

    if (engine._container._listeners['pressmove'] === undefined) {
      engine._listener.pm = engine._container.on('pressmove', engine._stageMouseMove, null, false, {
        engine: engine,
        cjsStage: stage,
      });
    }

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return false;
    }
    /** @typedef {Point} gp - obiekt z właściwościami x & y, które zostały przekształcone przy użyciu połączonej transformacji obiektu docelowego (this.moved) (tj. Włącznie z transformacjami macierzystymi). */
    let gp = stage.groups[engine.idGroup].container.localToGlobal(engine.x, engine.y),
      pt = { x: gp.x - stage.offset.x, y: gp.y - stage.offset.y },
      aid = Math.atan2(e.stageY - stage.offset.y - pt.y, e.stageX - stage.offset.x - pt.x) * (180 / Math.PI),
      tmp = Math.abs(aid),
      tmp1 = Math.abs(engine.rotation);

    engine.rotation = aid;

    /** gdy obracana wskazówka jest minutową */
    if (engine.type === 'min') {
      /** przypadek gdy wskazówka jest obracana do przodu */
      if ((aid < 0 && tmp - tmp1 < 0) || (aid > 0 && tmp - tmp1 > 0)) {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation += (Math.abs(tmp - tmp1) / 360) * angle;
      } else {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation -= (Math.abs(tmp - tmp1) / 360) * angle;
      }

      if (stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation === 0) {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].aid = 0;
      } else {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].aid =
          Math.round(stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation / angle) * angle;
        stage.groups[engine.move.idGroup].items[engine.move.idItem].aid =
          stage.groups[engine.move.idGroup].items[engine.move.idItem].aid === -0 ||
          stage.groups[engine.move.idGroup].items[engine.move.idItem].aid === 0
            ? 0
            : stage.groups[engine.move.idGroup].items[engine.move.idItem].aid;
      }
      /** wyliczenie kąta wskazówki godzinowej */
      if (Math.round(engine.rotation / angle) * angle === -90) {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation =
          Math.round(stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation / angle) * angle;
      }
    } else {
      /** ustawienie wskazówki minutowej na pozycji startowej */
      stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation =
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotStart;
    }

    /** zamknięcie kątów w zakresie -180 - 180 */
    stage.groups[engine.move.idGroup].items[engine.move.idItem].convert360to180();
  }

  stageMouseUp(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return;
    }

    if (engine.type == 'min') {
      /** ustawienie wskazówki zgodnie z ustawionym kątem */
      engine.rotation = Math.round(engine.rotation / engine.angleTips) * engine.angleTips;
      /** gdy wskazówka jest na godz. 12, ustawiana jest wskazówka godzinowa na pełną godzinę */
      if (engine.rotation == -90) {
        stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation =
          Math.round(stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation / angle) * angle;
      } else if (
        engine.rotation == 90 &&
        engine.angHr > stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation
      ) {
        /** przypadek gdy ma być ustawione na 30 min. i była cofana do tyłu */
        stage.groups[engine.move.idGroup].items[engine.move.idItem].aid =
          Math.floor(stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation / angle) * angle;
      }
      engine.rotation = engine.rotation === 180 || engine.rotation === -180 ? 180 : engine.rotation;
      stage.groups[engine.move.idGroup].items[engine.move.idItem].aid = Math.round(
        stage.groups[engine.move.idGroup].items[engine.move.idItem].aid
      );
      engine.aid = stage.groups[engine.move.idGroup].items[engine.move.idItem].aid;
    } else {
      engine.aid = Math.round(engine.rotation / angle) * angle;
      engine.rotation = Math.round(engine.rotation / angle) * angle;
    }

    stage.mousedown = false;
    engine._mousedown = false;
    engine._container.off('pressmove', engine._listener.pm);

    console.log(
      engine.id +
        ' cjsClock HR: ' +
        (engine.type === 'min' ? stage.groups[engine.move.idGroup].items[engine.move.idItem].aid : engine.rotation) +
        ' MIN: ' +
        (engine.type == 'min' ? engine.rotation : stage.groups[engine.move.idGroup].items[engine.move.idItem].rotation)
    );

    stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');
    e.stopPropagation();
  }

  convert360to180() {
    if (this.rotation % 360 > 180) {
      this.rotation = (this.rotation % 360) - 360;
    } else if (this.rotation % 360 === -180) {
      this.rotation = Math.abs(this.rotation % 360);
    } else {
      this.rotation = this.rotation % 360;
    }
  }

  get type() {
    return this._type;
  }
  get move() {
    return this._move;
  }
  get rotStart() {
    return this._rotStart;
  }
  get angleTips() {
    return this._angleTips;
  }

  get angHr() {
    return this._angHr;
  }
  set angHr(v) {
    this._angHr = v;
  }
  get aid() {
    return this._aid;
  }
  set aid(v) {
    this._aid = v;
  }
}
cjsClock.afterLoadSamples = function(stage) {
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];

      if (
        item.move !== false &&
        (typeof stage.groups[item.move.idGroup] !== 'object' || stage.groups[item.move.idGroup] === null)
      )
        throw 'Błędna konfiguracja grupy drugiej wskazówki w grupie: ' + gr + ' dla elementu: ' + i;
      if (
        item.move !== false &&
        (typeof stage.groups[item.move.idGroup].items[item.move.idItem] !== 'object' ||
          stage.groups[item.move.idGroup].items[item.move.idItem] === null)
      )
        throw 'Błędna konfiguracja elementu drugiej wskazówki w grupie: ' + gr + ' dla elementu: ' + i;
      if (item.move !== false && item.move.idGroup === gr && item.move.idItem === i)
        throw 'Błędna konfiguracja drugiej wskazówki w grupie: ' +
          gr +
          ' dla elementu: ' +
          i +
          '. Zostały wpisane te same ID grupy i Item';

      item.convert360to180();
      item._rotStart = _.cloneDeep(item.rotation);
    }
  }
};

cjsClock.checkGameAction = function(stage) {
  console.log('cjsClock CHECK');
  let isCorrect = true;
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].move === false) continue;
      stage.groups[gr].items[i].isCorrect = false;
    }
  }

  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].move === false) continue;
      if (stage.groups[gr].items[i].type === 'min') {
        for (let j = 0; j < stage.groups[gr].items[i].correct.length; j++) {
          if (
            stage.groups[gr].items[i].rotation === stage.groups[gr].items[i].correct[j].rotation ||
            stage.groups[gr].items[i].rotation === stage.groups[gr].items[i].correct[j].rotation - 360 ||
            stage.groups[gr].items[i].rotation === stage.groups[gr].items[i].correct[j].rotation + 360
          ) {
            stage.groups[gr].items[i].isCorrect = true;
            break;
          }
        }
        continue;
      }

      for (let j = 0; j < stage.groups[gr].items[i].correct.length; j++) {
        if (
          stage.groups[gr].items[i].aid === stage.groups[gr].items[i].correct[j].rotation ||
          stage.groups[gr].items[i].aid === stage.groups[gr].items[i].correct[j].rotation - 360 ||
          stage.groups[gr].items[i].aid === stage.groups[gr].items[i].correct[j].rotation + 360
        ) {
          stage.groups[gr].items[i].isCorrect = true;
          break;
        }
      }
    }

    for (let i in stage.groups[gr].items) {
      if (stage.groups[gr].items[i].move === false) continue;
      if (stage.groups[gr].items[i].isCorrect === false) {
        stage.groups[stage.groups[gr].items[i].move.idGroup].items[
          stage.groups[gr].items[i].move.idItem
        ].isCorrect = false;

        if (stage.removeInCorrects === true) {
          stage.groups[gr].items[i].rotation = _.cloneDeep(stage.groups[gr].items[i]._rotStart);
          stage.groups[stage.groups[gr].items[i].move.idGroup].items[
            stage.groups[gr].items[i].move.idItem
          ].rotation = _.cloneDeep(
            stage.groups[stage.groups[gr].items[i].move.idGroup].items[stage.groups[gr].items[i].move.idItem]._rotStart
          );
        }

        isCorrect = false;
      }
    }

    if (stage.correctBlock === true) {
      for (let i in stage.groups[gr].items) {
        if (stage.groups[gr].items[i].move === false) continue;
        if (stage.groups[gr].items[i].isCorrect === true) stage.groups[gr].items[i].block = true;
      }
    }
  }

  return isCorrect;
};

cjsClock.resetGameAction = function(stage) {
  console.log('cjsClock RESET');
  cjsClock.afterLoadSamples(stage);
};
